import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';
import useAxios from '../compositions/useAxios';
import { getToday, getLastDay } from '@/utils/dateCalculation';

// 로그인 여부 확인
function checkLogin(to, from, next, alertContent = '로그인이 필요합니다.') {
	if (store.state.token.access_token) {
		return;
	} else {
		// alert(alertContent); // 250626 앱쪽 삭제 요창받아 주석처리(웹에서 필요한지는 불투명)
		router.push({ name: 'Signin' });
	}
}

// 이미 로그인했을 시 다시 들어가는거 방지
function loginGuard(next, alertContent = '이미 로그인/회원가입 하셨습니다.') {
	if (!store.state.token.access_token) {
		next();
	} else {
		alert(alertContent);
		next({
			name: 'Home',
			query: {
				page: 1,
				filter_start_date: getToday(),
				filter_end_date: getLastDay(),
				state_type: '전체',
			},
		});
	}
}

// 유저 정보 갱신
const { fetchData } = useAxios();
async function getUserInfo() {
	await fetchData('/getUserInfo', (data) => {
		store.commit('user/setUserInfo', data.user);
	});
}

const routes = [
	{
		path: '/',
		name: 'Home',
		component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue'),
		beforeEnter: (to, from, next) => {
			checkLogin(to, from, next);
			next();
		},
	},
	{
		// Sign In
		path: '/signin',
		name: 'Signin',
		component: () => import(/* webpackChunkName: "signin" */ '../views/Signin.vue'),
		beforeEnter: (to, from, next) => {
			loginGuard(next);
		},
		props: true,
		meta: {
			title: '로그인',
		},
	},
	{
		// Sign Up
		path: '/signup',
		name: 'Signup',
		component: () => import(/* webpackChunkName: "signup" */ '../views/Signup.vue'),
		beforeEnter: (to, from, next) => {
			loginGuard(next);
		},
	},
	{
		// Change Password
		path: '/changePwd',
		name: 'ChangePwd',
		component: () => import(/* webpackChunkName: "changePwd" */ '../views/ChangePwd.vue'),
		beforeEnter: (to, from, next) => {
			loginGuard(next);
		},
	},
	{
		// List Detail
		path: '/listDetail',
		name: 'ListDetail',
		component: () => import(/* webpackChunkName: "listdetail" */ '../views/ListDetail.vue'),
		beforeEnter: (to, from, next) => {
			checkLogin(to, from, next);
			next();
		},
	},
	{
		// Inventory
		path: '/inventory',
		name: 'Inventory',
		component: () => import(/* webpackChunkName: "inventory" */ '../views/Inventory.vue'),
		beforeEnter: (to, from, next) => {
			checkLogin(to, from, next);
			next();
		},
	},
	{
		// Calendar
		path: '/calendar',
		name: 'Calendar',
		component: () => import(/* webpackChunkName: "calendar" */ '../views/Calendar.vue'),
		beforeEnter: (to, from, next) => {
			checkLogin(to, from, next);
			next();
		},
	},
	{
		// My Page
		path: '/mypage',
		name: 'MyPage',
		component: () => import(/* webpackChunkName: "MyPage" */ '../views/MyPage.vue'),
		beforeEnter: (to, from, next) => {
			checkLogin(to, from, next);
			next();
		},
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior() {
		return { top: 0 };
	},
});

router.beforeEach(async (to, from) => {
	if (store.state.user.isLogin && !store.state.token.access_token) {
		store.state.user.isLogin = false;
	} else if (store.state.token.access_token && !store.state.user.isLogin) {
		store.state.user.isLogin = true;
		await getUserInfo();
	}
});

export default router;
